<template>
  <div class="staff-stats">
    <div class="d-flex flex-wrap align-items-center mb-2">
      <span class="mr-1">期间(기간)</span>
      <input v-model="from" type="date" class="form-control form-control-sm staff-stats__date mr-1">
      <span class="mr-1">~</span>
      <input v-model="to" type="date" class="form-control form-control-sm staff-stats__date mr-2">
      <select v-model="group" class="form-control form-control-sm staff-stats__group mr-2">
        <option value="">全部分类(분류 전체)</option>
        <option v-for="g in groups" :key="g" :value="g">{{ g }}</option>
      </select>
      <button class="btn btn-sm btn-primary mr-2" type="button" :disabled="loading" @click="load">查询(조회)</button>
      <small class="text-muted">最多92天(최대 92일)</small>
    </div>

    <div class="table-responsive">
      <table class="table table-sm table-bordered staff-stats__table staff-stats__cards">
        <thead>
          <tr>
            <th rowspan="2">账号(아이디)</th>
            <th rowspan="2">姓名(이름)</th>
            <th rowspan="2">分类(분류)</th>
            <th colspan="4">入库(입고)</th>
            <th colspan="2">条码打印(바코드 출력)</th>
            <th colspan="2">出库(출고)</th>
            <th colspan="5">客服助手(CS 보조)</th>
          </tr>
          <tr>
            <th>件数(건)</th>
            <th>数量(수량)</th>
            <th title="入库件中客户要求基本验货的件数">含基本验货(기본검수 요청)</th>
            <th title="入库件中客户要求贴条码的件数">含条码标签(바코드 라벨 요청)</th>
            <th>次数(횟수)</th>
            <th>张数(장수)</th>
            <th>行数(줄)</th>
            <th>数量(수량)</th>
            <th>客户数(고객 수)</th>
            <th>回复数(답장 수)</th>
            <th>直接采用(그대로)</th>
            <th>修改后(고쳐서)</th>
            <th>自己输入(직접 입력)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="r in shownRows" :key="r.email || r.name" :class="{ 'text-muted': !r.staff }">
            <td data-label="账号">{{ r.email || '-' }}</td>
            <td data-label="姓名">{{ r.name }}<small v-if="!r.staff" class="d-block">非子账号(직원 계정 아님)</small></td>
            <td data-label="分类">{{ r.group || '-' }}</td>
            <td data-label="入库·件数">{{ r.receiptCount }}</td>
            <td data-label="入库·数量">{{ r.receiptQty }}</td>
            <td data-label="含基本验货">{{ r.receiptWithInspect }}</td>
            <td data-label="含条码标签">{{ r.receiptWithBarcode }}</td>
            <td data-label="条码·次数">{{ r.barcodePrints }}</td>
            <td data-label="条码·张数">{{ r.barcodeLabels }}</td>
            <td data-label="出库·行数">{{ r.shipRows }}</td>
            <td data-label="出库·数量">{{ r.shipQty }}</td>
            <td data-label="客服·客户数">{{ r.csCustomers }}</td>
            <td data-label="客服·回复数">{{ r.csAnswers }}</td>
            <td data-label="直接采用">{{ r.csAsIs }}</td>
            <td data-label="修改后">{{ r.csEdited }}</td>
            <td data-label="自己输入">{{ r.csOwn }}</td>
          </tr>
          <tr v-if="!shownRows.length">
            <td colspan="16" class="text-center text-muted">{{ loaded ? '暂无数据(데이터 없음)' : '请选择期间后查询(기간을 고르고 조회해 주세요)' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <ul class="staff-stats__notes text-muted small pl-3">
      <li>入库: 按入库处理画面的处理人统计{{ sinceText('receipt') }}(입고: 입고처리 화면에서 처리한 사람 기준{{ sinceText('receipt', true) }}).</li>
      <li>含基本验货·含条码标签: 是该账号入库的件中客户要求了该作业的件数，不是实际操作记录(그 계정이 입고 처리한 건 중 화주가 그 작업을 요청한 건수입니다 — 실제로 검수·부착한 기록은 아닙니다).</li>
      <li>条码打印: 从本次更新开始记录，之前的打印无法显示{{ sinceText('barcodePrint') }}(바코드 출력: 이번 업데이트부터 기록합니다 — 그 전 출력은 볼 수 없습니다{{ sinceText('barcodePrint', true) }}).</li>
      <li>客服助手: 只统计使用客服助手发送的回复{{ sinceText('csDraft') }}。不用客服助手、直接在客服后台回复的消息没有记录是谁发的，所以无法计算「客服助手使用比例」(CS 보조로 보낸 답장만 셉니다{{ sinceText('csDraft', true) }}. CS 보조 없이 상담 관리자 화면에서 바로 보낸 답장은 누가 보냈는지 기록이 없어 「CS 보조 사용 비율」은 계산할 수 없습니다).</li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios';

// 중국 창고 기준(UTC+8) 날짜 'YYYY-MM-DD'
function cnDate(offsetDays) {
  const d = new Date(Date.now() + 8 * 3600e3 + (offsetDays || 0) * 864e5);
  return d.toISOString().slice(0, 10);
}

export default {
  name: 'CoupassStaffStats',
  props: {
    groups: { type: Array, default: () => [] },
  },
  data() {
    return { from: cnDate(-6), to: cnDate(0), group: '', rows: [], since: {}, loading: false, loaded: false };
  },
  computed: {
    shownRows() {
      return this.group ? this.rows.filter(r => r.group === this.group) : this.rows;
    },
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const res = await axios.post('/api/coupass-staff/stats', { from: this.from, to: this.to });
        if (res.data && res.data.success) {
          this.rows = res.data.rows || [];
          this.since = res.data.since || {};
          this.loaded = true;
        }
      } catch (e) {
        console.error('작업량 통계 조회 실패:', e);
        alert((e.response && e.response.data && e.response.data.message) || '查询失败(조회 실패)');
      } finally {
        this.loading = false;
      }
    },
    sinceText(key, ko) {
      const v = this.since && this.since[key];
      if (!this.loaded) return '';
      if (!v) return ko ? ', 아직 기록 없음' : '，暂无记录';
      const d = new Date(new Date(v).getTime() + 8 * 3600e3).toISOString().slice(0, 10);
      return ko ? ', ' + d + ' 부터 기록' : '，' + d + ' 起有记录';
    },
  },
};
</script>

<style lang="scss" scoped>
.staff-stats {
  &__date { max-width: 150px; }
  &__group { max-width: 180px; }
  &__table th { white-space: nowrap; font-size: 0.85rem; }
  // 이름·아이디는 한 줄로 — 칸이 좁아 「[시험] 가 직원」이 한 자씩 꺾였다(1440·390)
  @media (min-width: 577px) { &__table td:nth-child(-n+3) { white-space: nowrap; } }
  // 좁은 화면(≤576px): 표 행을 카드처럼 세로로(RecipientAliasPanel·LedgerCostManager 무늬) — 390 에서 16칸 표를 가로로 밀어야 했다. 칸 이름은 td data-label
  @media (max-width: 576px) {
    &__cards {
      display: block;

      thead { display: none; }
      tbody { display: block; }
      tbody tr {
        display: block;
        padding: 6px 0;
        border-bottom: 1px solid #e1e6ea;
      }
      tbody td {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 4px 8px;
        border: 0;
        padding: 3px 4px;
        text-align: left;
        white-space: normal;

        &[data-label]::before {
          content: attr(data-label);
          flex: 0 0 72px;
          font-size: 12px;
          color: #7f8c9a;
        }
        // 칸 안 둘째 줄은 칸 이름 폭만큼 들여 값 줄과 맞춘다
        > div, > small { flex: 1 1 100%; padding-left: 80px; }
      }
      td[colspan] { justify-content: center; }
    }
  }
  &__notes li { margin-bottom: 2px; }
}
</style>
